import $ from 'jquery';
import plugin from '@core/plugins/lib';
import { onAvailable } from "@core/plugins/lib/selectors";


export const ELEMENT_SELECTOR = '[data-focus-within]';
export const PLUGIN_NAME = 'FocusWithin';



$(() => {
	onAvailable.ready(ELEMENT_SELECTOR, function (element) {
		System.import(
			/* webpackChunkName: "plugin--focus-within" */ './plugin.js'
		).then((module) => {
			plugin(PLUGIN_NAME, module.default);
			$(element)[PLUGIN_NAME]();
		});
	});
});



// WEBPACK FOOTER //
// ./project/client/src/core/plugins/jquery__focus-within/index.js